import React from "react";
import { Card, Table, Row } from "react-bootstrap";

import { useState, useEffect } from "react";
import { getPlanTotals } from "../../../../apis/options/PlanApi";
import { useHistory } from "react-router-dom";
import IntegerFmt from "../../../common/typeFormatting/IntegerFmt";
import Dollars from "../../../common/typeFormatting/Dollars";

export default function PlanTotals({planAddedNotify}) {
    
    let history = useHistory();

    const [planTotals, setPlanTotals] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                const totals = await getPlanTotals();
                totals.sort((a,b) =>  b.year - a.year);
                setPlanTotals(totals);
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
            }
        }

        fetchData();
    }, [planAddedNotify]);

    const planSelected = (pid) => {
        history.push(`/options/plans/${pid}`);
    }

    // Calculate totals for the footer row
    const calculateTotals = () => {
        if (!planTotals || planTotals.length === 0) return null;
        
        return {
            allShares: planTotals.reduce((sum, plan) => sum + plan.allShares, 0),
            maxPlanOptions: planTotals.reduce((sum, plan) => sum + plan.maxPlanOptions, 0),
            remaining: planTotals.reduce((sum, plan) => sum + (plan.maxPlanOptions - plan.allShares), 0),
            allSharesPosValue: planTotals.reduce((sum, plan) => sum + plan.allSharesPosValue, 0),
            allSharesValue: planTotals.reduce((sum, plan) => sum + plan.allSharesValue, 0),
            vestedSharesPosValue: planTotals.reduce((sum, plan) => sum + plan.vestedSharesPosValue, 0),
            vestedSharesValue: planTotals.reduce((sum, plan) => sum + plan.vestedSharesValue, 0)
        };
    }

    const totals = planTotals ? calculateTotals() : null;

    return (
        <div>
            <Card style={{marginTop: 25}}>
                <Card.Body>
                    <Card.Title>Plans</Card.Title>
                    <Row>
                        {!loading ? 
                            <Table hover responsive style={{fontSize: 12, overflowY: "auto"}} >
                                <thead style={{position: "sticky", top: 0}}>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th  style={{backgroundColor: "rgb(243,243,243,1)"}} colSpan={2}>All Shares</th>
                                        <th  style={{backgroundColor: "rgb(235,235,235,1)"}} colSpan={2}>Vested Shares</th>
                                    </tr>
                                    <tr>
                                        <th>Plan Name</th>
                                        <th className="text-right"><div>Granted / Max Avail</div></th>
                                        <th className="text-right">Remaining</th>
                                        <th className="text-right">Current Price</th>
                                        <th style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right"><div>Positive Values</div></th>
                                        <th style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right">Total Value</th>
                                        <th  style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right"><div>Positive Values</div></th>
                                        <th  style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right">Total Value</th>                                     
                                    </tr>
                                </thead>
                                <tbody>
                                    {planTotals.map(d => (
                                        <tr key={d.planId} onClick={() => planSelected(d.planId)} className={'table-row' + (d.isNew ? ' show' : '')}>
                                            <td>{d.name}</td>
                                            <td className="text-right"><IntegerFmt>{d.allShares}</IntegerFmt><span>&nbsp;/&nbsp;</span><IntegerFmt>{d.maxPlanOptions}</IntegerFmt></td>
                                            <td className="text-right"><IntegerFmt>{d.maxPlanOptions - d.allShares}</IntegerFmt></td>
                                            <td className="text-right"><Dollars>{d.currentPrice}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right"><Dollars>{d.allSharesPosValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right"><Dollars>{d.allSharesValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right"><Dollars>{d.vestedSharesPosValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right"><Dollars>{d.vestedSharesValue}</Dollars></td>
                                        </tr>                   
                                    ))}                                     
                                </tbody>
                                <tfoot style={{fontWeight: "bold", borderTop: "2px solid #dee2e6"}}>
                                    {totals && (
                                        <tr>
                                            <td>TOTAL</td>
                                            <td className="text-right"><IntegerFmt>{totals.allShares}</IntegerFmt><span>&nbsp;/&nbsp;</span><IntegerFmt>{totals.maxPlanOptions}</IntegerFmt></td>
                                            <td className="text-right"><IntegerFmt>{totals.remaining}</IntegerFmt></td>
                                            <td></td>
                                            <td style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right"><Dollars>{totals.allSharesPosValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(243,243,243,1)"}} className="text-right"><Dollars>{totals.allSharesValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right"><Dollars>{totals.vestedSharesPosValue}</Dollars></td>
                                            <td style={{backgroundColor: "rgb(235,235,235,1)"}} className="text-right"><Dollars>{totals.vestedSharesValue}</Dollars></td>
                                        </tr>
                                    )}
                                </tfoot>
                            </Table>
                            : <div></div>
                        }                    
                    </Row>                
                </Card.Body>
            </Card>                 
        </div>        
    );
}